import { Field, Formik } from "formik";
import { isEmpty } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import firebase from "../../firebase";
// Firebase modular imports
import { getFirestore, collection, query as fbQuery, where, getDocs } from "firebase/firestore";
import { Client, Content } from "../../interfaces";
import { TypedUseSelectorHook } from "../../redux";
import { fetchChannels, fetchClient, fetchContents, fetchTags } from "../../services/dataHelpers";
import { PageContainer, Well } from "./UI";

const Title = styled.h1`
	color: #fff;
`;

const ClientItem = styled.div`
	cursor: pointer;
`;

const useTypedSelector: TypedUseSelectorHook = useSelector;

const DashboardPickClient: React.FC = () => {
	const [clientList, setClientList] = useState<Client[]>([]);
	const [isGlobalUser, setIsGlobalUser] = useState<boolean>(false);
	const [loading, setLoading] = useState(true);
	const [query, setQuery] = useState("");

	const appUser = useTypedSelector(store => store.user.appUser);
	const dispatch = useDispatch();
	const history = useHistory();

	const db = getFirestore(firebase);

	const fieldRef = useRef();

	useEffect(() => {
		if (isGlobalUser) {
			setTimeout(() => {
				//@ts-ignore
				fieldRef.current?.focus();
			}, 200);
		}
	}, [isGlobalUser]);

	useEffect(() => {
		if (clientList.length === 1) {
			const client = clientList[0];
			let url = "//" + window.location.host + `/dashboard/${client.id}/channels`;
			window.open(url, "_self");
		}
	}, [clientList]);

	if (loading && appUser) {
		if (appUser.globalRole === "owner" || appUser.globalRole === "admin") {
			setIsGlobalUser(true);
			const clientsCollection = collection(db, "clients");
			getDocs(clientsCollection).then(querySnapshot => {
				let tempClientsList: Client[] = [];

				querySnapshot.forEach(doc => {
					const client = doc.data() as Client;
					if (!client.versionCode) {
						tempClientsList.push(client);
					}
				});
				setClientList(tempClientsList);
			});
			setLoading(false);
		} else {
			const clientsCollection = collection(db, "clients");
			const clientsQuery = fbQuery(clientsCollection, where("id", "in", Object.keys(appUser.clients)));

			getDocs(clientsQuery).then(querySnapshot => {
				let tempClientsList: Client[] = [];
				querySnapshot.forEach(doc => tempClientsList.push(doc.data() as Client));
				setClientList(tempClientsList);
			});
			setLoading(false);
		}

		return null;
	}

	const onClientClick = (id: string) => {
		fetchClient(id, dispatch, appUser);
		fetchChannels(id, dispatch);
		fetchTags(id, dispatch);
		fetchContents(id, dispatch);
		history.push(`/dashboard/${id}/channels`);
	};

	let filteredList = clientList.concat();

	if (filteredList && query && query !== "") {
		let q = query.toLowerCase();
		filteredList = filteredList.filter(
			client =>
				client.name.toLowerCase().includes(q) ||
				client.city?.toLowerCase().includes(q) ||
				client.region?.toLowerCase().includes(q) ||
				client.key.toLowerCase().includes(q)
		);
	}

	filteredList.sort((a, b) => (a.name > b.name ? 1 : -1));
	const showItems = !isGlobalUser || (isGlobalUser && !isEmpty(query));

	return (
		<PageContainer size="md" className="no-sidebar m-top-large" htmlPageTitle="Choose an Organization">
			<div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
				<div>
					<Title>CHOOSE AN ORGANIZATION</Title>
				</div>
				<Well>
					{isGlobalUser && (
						<Formik initialValues={{ query: "" }} onSubmit={() => Promise.resolve(true)}>
							{({ handleSubmit, values }) => {
								setQuery(values.query);
								return (
									<form onSubmit={handleSubmit}>
										<div className="field">
											<Field
												type="text"
												name="query"
												placeholder="Type To Search"
												className="field margin-bottom"
												innerRef={fieldRef}
											/>
										</div>
									</form>
								);
							}}
						</Formik>
					)}
					{showItems && (
						<div className="mt-4">
							{filteredList.map(({ id, name, city, country }) => {
								return (
									<ClientItem className="btn-row" key={id} onClick={() => onClientClick(id)}>
										<i className="fal fa-chevron-right" />
										<h2 style={{ color: "white" }}>{name}</h2>
										{city && country && <p style={{ color: "white" }}>{`${city} ${country}`}</p>}
									</ClientItem>
								);
							})}
						</div>
					)}
				</Well>
			</div>
		</PageContainer>
	);
};

export default DashboardPickClient;
